import { render, staticRenderFns } from "./map-pc.vue?vue&type=template&id=63a6548c&scoped=true&"
import script from "./map-pc.vue?vue&type=script&lang=js&"
export * from "./map-pc.vue?vue&type=script&lang=js&"
import style0 from "./map-pc.vue?vue&type=style&index=0&id=63a6548c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a6548c",
  null
  
)

export default component.exports